export function toRecord(input: unknown): Record<string, unknown> {
  return isRecord(input) ? input : {};
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  const prototype: unknown = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

export function getPath(object: unknown, path: readonly string[]): unknown {
  return path.reduce<unknown>((value, segment) => {
    if (!isRecord(value)) {
      return undefined;
    }
    if (!Object.prototype.hasOwnProperty.call(value, segment)) {
      return undefined;
    }
    return value[segment];
  }, object);
}

export function setPath(
  object: Record<string, unknown>,
  path: readonly string[],
  value: unknown,
): void {
  const [head, ...tail] = path;
  if (!head) return;
  if (tail.length === 0) {
    object[head] = value;
    return;
  }
  const next = object[head];
  if (!isRecord(next)) {
    object[head] = {};
  }
  setPath(object[head] as Record<string, unknown>, tail, value);
}
